import React, { useState } from 'react';
import Manage_store from './manage store/Manage_store'; 
import Manage_billing from './manage billing/Manage_billing';
import Manage_salesmen from './manage salesmen/Manage_salesmen';
import Manage_staf from './manage staf/Manage_staf';
import style from './Administration.module.css'; 

const Administration = () => {
  const [activeComponent, setActiveComponent] = useState('currentDetails'); 

  const handleButtonClick = (component) => {
    setActiveComponent(component);
  };

  return (
    <>
      <div className={style.adminselector}>
        <button 
          className={activeComponent === 'currentDetails' ? style.active : ''} 
          onClick={() => handleButtonClick('currentDetails')}
        >
          Admin
        </button>
        <button 
          className={activeComponent === 'store' ? style.active : ''} 
          onClick={() => handleButtonClick('store')}
        >
          Manage Store
        </button>
        <button 
          className={activeComponent === 'billing' ? style.active : ''} 
          onClick={() => handleButtonClick('billing')}
        >
          Manage Billing
        </button>
        <button 
          className={activeComponent === 'salesmen' ? style.active : ''} 
          onClick={() => handleButtonClick('salesmen')}
        >
          Manage Salesmen
        </button>
        <button 
          className={activeComponent === 'staff' ? style.active : ''} 
          onClick={() => handleButtonClick('staff')}
        >
          Manage Staff
        </button>
      </div>

      <div className={style.displaycomponent}>
        {activeComponent === 'currentDetails' && (
          <div className={style.currentDetails}>
            <h2>ADMIN</h2>
            <p>Current data or overview goes here.</p>
          </div>
        )}
        {activeComponent === 'store' && <Manage_store />}
        {activeComponent === 'billing' && <Manage_billing />}
        {activeComponent === 'salesmen' && <Manage_salesmen />}
        {activeComponent === 'staff' && <Manage_staf />}
      </div>
    </>
  );
};

export default Administration;
